import Train from '@/views/Train/index.vue'

const TrainRouter = {
  path: '/train',
  name: 'Train',
  component: Train,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default TrainRouter
